module.exports = __webpack_public_path__ + "static/img/jk_jcjg_icon.png";